import api, { apiPrefix } from './Api';
import { Banner, bannerFromResponse } from '../interfaces/Banner/Banner';
import { Pagination, paginationToParams } from '../interfaces/Pagination';
import { PaginatedResponse } from '../interfaces/PaginatedResponse';

const bannerApiPrefix = `${apiPrefix}/banners`;

export const getBanners = async (
  pagination: Pagination,
): Promise<PaginatedResponse<Banner>> => {
  const response = await api.get(bannerApiPrefix, {
    params: { ...paginationToParams(pagination), 'include-inactive': true },
  });

  return {
    data: (response.data?.data ?? []).map((banner: any) =>
      bannerFromResponse(banner),
    ),
    totalCount: response.data?.total_count ?? 0,
  };
};
